<template>
  <div class="welcome-container">
    <!-- welcome sections -->
    <div class="welcome-section">
      <slot>
        <div class="welcome-text mt-5">
          Finde dein Elektroauto!
        </div>
        <div class="tag-info mx-auto text-center">
          <div>
            Neu, sofort verfügbar, alles online, Lieferung bis vor die Haustür. Let's go!
          </div>
        </div>
      </slot>
      <div v-if="hideStart !== true" @click="$emit('onStart')" class="start-btn mx-auto pointer">
      </div>
    </div>
    <!-- all cars -->
    <div class="all-cars text-center color-primary mt-8 size-24 font-weight-bold col-flex">
      Alle Autos
      <v-icon>mdi-chevron-down</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cover-section',
  props: ['hideStart']
}
</script>

<style lang="scss" scoped>
.welcome-container {
  height: 100%;
  max-height: 731px;
  display: flex;
  flex-direction: column;
}
@media only screen and (max-width: 499px) {
  .welcome-container {
    // min-height: 100vh;
    height: 100vh;
    // min-height: 100vh;
  }
}
.welcome-section {
  padding-bottom: 60px;
  padding-top: 110px;
  width: 100%;
  height: calc(100% * 0.85);
  background-image: url('~@/assets/img/background1.png');
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .welcome-text {
    max-width: 360px;
    margin-left: auto;
    margin-right: auto;

    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 34px;
    line-height: 41px;
    text-align: center;

    color: #FFFFFF;
  }

  .tag-info {
    max-width: 250px;
    margin-top: 32px;
    margin-bottom: 32px;

    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 26px;
    color: #FFFFFF;
  }

  .start-btn {
    background-image: url('~@/assets/img/start.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    height: 194px;
    min-height: 124px;
    width: 200px;
    border-radius: 100%;
    transition: all 0.25s;
  }
  .start-btn:hover {
    transform: scale(1.02);
  }

}
@media only screen and (max-width: 320px) {
  .welcome-section {
    padding-top: 100px;
    padding-bottom: 40px;

    .welcome-text {
      font-size: 28px;
    }
    .tag-info {
      font-size: 16px;
      margin-top: 32px;
      margin-bottom: 32px;
    }
  }
  .all-cars {
    margin-top: 20px !important;
    font-size: 20px !important;
  }
}
@media only screen and (max-width: 360px) {
  .start-btn {
    max-width: 180px;
  }
}
</style>